export const HISTORY_EVENTS = {
    created: "history_created",
    updated: "history_updated",
    deleted: "history_deleted",
    init: "history_init",
    sync: "history_sync",
};
export const HISTORY_CONTEXT = "history";
//# sourceMappingURL=history.js.map